import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { Box, Typography } from '@material-ui/core';
import { colors } from '../../theme/color-palette';
import { useMediaQuery } from '@mui/material';
const { FONT_COLOR } = colors;

const useStyles = makeStyles(() => ({
	noDataMsg: {
		position: 'absolute',
		width: '100%',
		bottom: (P) => (P.isSmallScreen ? '35%' : '50%'),
		textAlign: 'center',
		fontFamily: 'Bogle-Regular',
		fontSize: '16px',
		color: FONT_COLOR,
	},
	noData: {
		height: 'inherit',
		textAlign: 'center',
		border: 'none',
		boxShadow: 'none',
		position: 'relative',
		paddingBottom: '16px',
		margin: '16px',
	},
	noDataTabPanel: {
		height: 'inherit',
		textAlign: 'center',
		border: 'none',
		boxShadow: 'none',
		position: 'relative',
		paddingBottom: '16px',
		marginTop: '100px',
		marginBottom: '16px',
		marginLeft: '16px',
		marginRight: '16px',
	},
	chartTitle: {
		textAlign: 'left',
		fontSize: '18px',
		color: FONT_COLOR,
		fontFamily: 'Bogle-Regular',
	},
}));

const ErrorScreenMessage = (props) => {
	const {
		errorMsg,
		chartTitle,
		isMuiTableContainer,
		showTitleInContent,
		isInsideTabPanel,
	} = props;
	const isSmallScreen = useMediaQuery('(max-width:380px)');
	const classes = useStyles({ isSmallScreen });
	const content = showTitleInContent ? `${chartTitle} ${errorMsg}` : errorMsg;
	let insideTabPanelClass;
	if (isInsideTabPanel) {
		insideTabPanelClass = classes.noDataTabPanel;
	} else {
		insideTabPanelClass = classes.noDataMsg;
	}

	return (
		<Box className={classes.noData}>
			{!isMuiTableContainer ? (
				<>
					<Typography className={classes.chartTitle}>{chartTitle}</Typography>
					<Typography className={insideTabPanelClass}>{content}</Typography>
				</>
			) : (
				<Typography
					className={classes.noDataMsg}
					style={{ paddingBottom: '62px' }}>
					{content}
				</Typography>
			)}
		</Box>
	);
};

ErrorScreenMessage.defaultProps = {
	errorMsg: '',
	chartTitle: '',
	isMuiTableContainer: false,
	showTitleInContent: true,
	isInsideTabPanel: false,
};

ErrorScreenMessage.propTypes = {
	errorMsg: PropTypes.string,
	chartTitle: PropTypes.string,
	isMuiTableContainer: PropTypes.bool,
	showTitleInContent: PropTypes.bool,
	isInsideTabPanel: PropTypes.bool,
};

export default ErrorScreenMessage;
